import React, { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useAuth0 } from "@auth0/auth0-react";
import {
    Box,
    ListItemIcon,
    ListItemText,
    MenuList,
    MenuItem,
    Paper,
} from "@mui/material";

import GradingIcon from '@mui/icons-material/Grading';
import ProjectContext from '../../contexts/ProjectContext';
import RightClickMenu from "./RightClickMenu";
import OverrideWarningDialog from "../dialog/OverrideWarningDialog";
import {useFetch} from '../../components/auth/useFetch';
import PermissionGuard from "../../contexts/PermissionContext";


export default function ExportsRightClick(props) {

    const { children, active, exports, filename, payload } = props
    const projectContext = useContext(ProjectContext);
    const [menuPosition, setMenuPosition] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false)
    const fetchWithAuth = useFetch()



    const handleContextMenu = (event) => {
        event.preventDefault();
        setMenuPosition(
            menuPosition === null
            ?
                {
                    mouseX: event.clientX,
                    mouseY: event.clientY
                }
            :
                null
        );
    };

    const menuClose = () => {
        setMenuPosition(null)
    };

    const dialogClose = () => {
        setDialogOpen(false)
    }

    const onOverrideClick = () => {
        setDialogOpen(true)
        menuClose()
    };

    function downloadExport (data) {
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/assets/?output_type=pdf&pdf_name=${exports?.name}`, {
            method: 'PATCH',
            headers: {
                'X-Project-ID': projectContext?.project_db,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
        })
        .then(response => response.blob())
        .then(res => {
            const url = window.URL.createObjectURL(res);
    
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(e => {
            console.error(e);
        })
    }

    return (
        <>
            <RightClickMenu
                content={
                    exports?.type === 'ARCHIVE' && <MenuList>
                        <PermissionGuard permission={['verify:media']}>
                            <MenuItem onClick={onOverrideClick}>
                                <ListItemIcon><GradingIcon  style={{fill: 'rgb(255, 255, 255)'}}/></ListItemIcon>
                                <ListItemText>{`Override ${exports?.name ?? 'Report'}`}</ListItemText>
                            </MenuItem>
                        </PermissionGuard>
                    </MenuList>
                }
                handleClose={menuClose}
                handleContextMenu={(e) => active && handleContextMenu(e)}
                menuPosition={menuPosition}
            >
                {children}
            </RightClickMenu>
            {dialogOpen && createPortal(
                <OverrideWarningDialog
                    clickAway={dialogClose}
                    downloadClick={downloadExport}
                    exportName={exports?.name ?? 'Report'}
                    open={dialogOpen}
                    payload={payload}
                />
                ,document.body
            )}
        </>
    )
}